import { isValueExist } from '@util';

const baseURL = '/user';

async function linkFacebook(facebookPageId, facebookUserToken) {
    const res = await axios.post(`${baseURL}/linkFacebook`, {
        facebookPageId,
        facebookUserToken,
    });
    return true;
}

async function get() {
    const res = await axios.get(baseURL);
    return res.data;
}

async function authGet() {
    const res = await axios.get('/auth/user');
    return res.data;
}

async function update(data) {
    const res = await axios.put(baseURL, data);
    return res.data;
}

async function updateBizNo(bizNo) {
    const res = await axios.put(`${baseURL}/bizNo`, { business_no: bizNo });
    return res.data;
}

async function rank() {
    const res = await axios.get(`${baseURL}/rank`);
    return res.data;
}

async function destroy(password) {
    const res = await axios.delete(baseURL, { data: { password } });
    return res.data;
}

async function deletable() {
    const res = await axios.get(`${baseURL}/deletable`);
    return res.data.deletable;
}

async function submitBusinessCertification(file) {
    let formData = new FormData();
    formData.append('file', file);
    return axios
        .post(`${baseURL}/uploadBusinessCertification`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((res) => {
            return res.data;
        });
}

async function deleteAccount(id) {
    return await axios.delete(`/accounts/${id}`);
}

function createAccount(account) {
    return axios.post('/accounts', account).then(R.prop('data'));
}

function setDefaultAccount(id) {
    return axios.post(`/accounts/${id}/setDefault`).then(R.prop('data'));
}

async function fetchNbFeeds(id) {
    const res = await axios.get(`${baseURL}/${id}/nbFeeds`);
    return res.data;
}

function reqKakaoNotiAuthCode(phone) {
    return axios
        .post(`/notifications/phone_authentication`, { phone })
        .then(R.prop('data'))
        .catch(R.prop('response'));
}

function submitKakaoNotiAuthCode(authCode) {
    return axios
        .post(`notifications/phone_authcode`, { authCode })
        .then()
        .catch(R.prop('response'));
}

function setKakaoNoti(kakaotalk) {
    return axios.post('notifications/settings', {
        kakaotalk,
    });
}

function deletePhoneNum() {
    return axios.delete(`${baseURL}/phone`);
}

async function fetchUser(id, fields = []) {
    fields = R.compose(R.join('&'), R.map(R.concat('fields[]=')))(fields);

    let url = `${baseURL}/${id}`;

    if (isValueExist(fields)) {
        url += `?${fields}`;
    }

    const res = await axios.get(url);

    return res.data;
}

// Remembers the last opened workspace / view on the server (users.meta), so
// they follow the user across devices and survive the logout storage wipe.
// Only `lastWorkspaceId` and `lastViewId` are accepted; `null` clears one.
// The server ignores the call while a backoffice user is impersonating.
function patchUserMeta(body) {
    return axios.patch(`${baseURL}/meta`, body);
}

function updateMarketingConsent(body) {
    return axios.put(`${baseURL}/marketingConsent`, body);
}

function getMarketingConsent() {
    return axios.get(`${baseURL}/marketingConsent`).then(R.prop('data'));
}

export default {
    get,
    authGet,
    update,
    updateBizNo,
    linkFacebook,
    rank,
    destroy,
    deletable,
    submitBusinessCertification,
    deleteAccount,
    createAccount,
    setDefaultAccount,
    patchUserMeta,
    fetchNbFeeds,
    reqKakaoNotiAuthCode,
    submitKakaoNotiAuthCode,
    setKakaoNoti,
    fetchUser,
    deletePhoneNum,
    updateMarketingConsent,
    getMarketingConsent,
};
